module.exports = __webpack_public_path__ + "img/vision.1bfafc14.svg";